module.exports = __webpack_public_path__ + "static/media/banner@768.342983a5.png";